<div class="mail-details-container">
  <div class="mail-details-container__body">
    <app-mail-details-body></app-mail-details-body>
  </div>
  <div class="mail-details-container__categorizer">
    <app-mail-details-categorizer></app-mail-details-categorizer>
  </div>
</div>
